export default __webpack_public_path__ + "static/media/frog2.568c0bbb.png";